import { useContext, useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Home from "../Home/Home";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../LoginPage/GlobalContext";

const api_url = process.env.REACT_APP_API_URL;

const User = () => {
  const navigate = useNavigate();

  const [view, setView] = useState(false);
  const [update, setUpdate] = useState(false);
  const [create, setCreate] = useState(false);

  const [userData, setUserData] = useState([]);

  const [profileData, setProfileData] = useState([]);

  const { userId, setUserId } = useGlobalContext();

  useEffect(() => {
    fetch(`${api_url}/getuser`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const userObject = data.find(
          (user) => user._id === sessionStorage.userId
        );
        // setIsValidUser(userObject.active);

        if (!userObject.active) {
          navigate("/");
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
    profilesDataFetcher();
  }, []);

  const profilesDataFetcher = async () => {
    try {
      const response3 = await fetch(`${api_url}/getprofiles`);
      if (!response3.ok) {
        throw new Error(`HTTP error! Status:${response3.status}`);
      }
      const resData3 = await response3.json();
      const UserProfileData = resData3.filter(
        (profile) => profile.profileName === sessionStorage.userProfile
      );
      setProfileData(UserProfileData);
      setView(UserProfileData[0].status.user.view);
      setUpdate(UserProfileData[0].status.user.edit);
      setCreate(UserProfileData[0].status.user.create);
    } catch (error) {
      console.error("Error fetching profiles data:", error);
    }
  };

  const onEditClick = (_id) => {
    setUserId(_id);
    navigate("/edituser");
  };

  useEffect(() => {
    fetch(`${api_url}/getuser`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => setUserData(data));
  }, []);

  const getDateFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "name", //access nested data with dot notation
        header: "Name",
        size: 20,
      },
      {
        accessorKey: "email", //access nested data with dot notation
        header: "Email",
        size: 20,
      },
      {
        accessorKey: "mobileNumber", //access nested data with dot notation
        header: "Phone",
        size: 20,
      },
      {
        accessorKey: "userName", //access nested data with dot notation
        header: "Username",
        size: 20,
      },
      {
        accessorKey: "password",
        header: "Password",
        size: 20,
      },
      {
        accessorKey: "profile",
        header: "Profile",
        size: 20,
      },
      {
        accessorKey: "active",
        header: "Status",
        size: 20,
        accessorFn: (row) => (row.active ? "On" : "Off"),
      },
      {
        accessorKey: "createdAt",
        header: "Created At",
        accessorFn: (row) => getDateFormat(row.createdAt),
      },
      {
        accessorKey: "Action",
        header: "Action",
        // size: 50,
        // You can create a custom function to render an edit button
        accessorFn: (rowData) => (
          <button
            className="niveshartha_btn_add"
            onClick={() =>
              update
                ? onEditClick(rowData._id)
                : alert("You Don't have the access to edit")
            }
          >
            Edit
          </button>
        ),
      },
    ],
    [update, profileData]
  );

  const table = useMaterialReactTable({
    columns,
    data: userData, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    // initialState: { e: false },
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    enableHiding: false,
    paginationDisplayMode: "pages",
    muiTablePaperProps: {
      elevation: 0,
    },
    globalFilterFn: "contains",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  });

  return (
    <div>
      <Home />
      {view && (
        <div>
          <div className="table-button-container">
            {create && (
              <div className="niveshartha-btn-container">
                <Link to="/adduser">
                  <button className="niveshartha_btn_add">Add User</button>
                </Link>
              </div>
            )}
            <div className="user-table-container">
              <MaterialReactTable table={table} />
            </div>
          </div>
        </div>
      )}
      {!view && (
        <div className="user-table-container loading-gif">
          <img src="/loading.gif" alt="loading"></img>
        </div>
      )}
    </div>
  );
};

export default User;
